import { createReducer, on } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {
  courseTeachersListLoad,
  courseTeachersListLoadSuccess,
  courseTeachersListLoadFail,
  courseTeachersListUpdate,
  courseTeachersDelete,
  courseTeachersListReset,
} from "../../actions/admin/course-teachers.actions";
import {
  SubGroup,
  SubscriptionOrganization,
} from "src/app/shared/interfaces/orgadmin/course-organization";

export interface CourseTeachersListState {
  teachers: SubscriptionOrganization | null;
  subId: string | null;
  error: HttpErrorResponse | null;
}

const initialState: CourseTeachersListState = {
  teachers: null,
  subId: null,
  error: null,
};

export const courseTeachersListReducer = createReducer(
  initialState,
  on(
    courseTeachersListReset,
    (_state): CourseTeachersListState => initialState,
  ),
  on(
    courseTeachersListLoad,
    (state, action): CourseTeachersListState => ({
      ...state,
      teachers: state.subId === action.subId ? state.teachers : null,
      subId: action.subId,
      error: null,
    }),
  ),
  on(
    courseTeachersDelete,
    (state, action): CourseTeachersListState => ({
      ...state,
      teachers: {
        ...state.teachers,
        subgroups: state.teachers?.subgroups?.filter(
          (subgroup) => subgroup.id !== action.teamId,
        ),
      },
    }),
  ),
  on(courseTeachersListUpdate, (state, action): CourseTeachersListState => {
    const updatedTeacherIds = new Set(
      action.teachers.teachers.map((teacher) => teacher.id),
    );
    const existingSubgroupIndex = state.teachers.subgroups.findIndex(
      (subgroup) => subgroup.id === action.teachers.id,
    );
    const updatedSubgroups = state.teachers.subgroups.reduce(
      (subgroups, subgroup, index) => {
        const hasUpdatedTeacher = subgroup.teachers.some((teacher) =>
          updatedTeacherIds.has(teacher.id),
        );

        if (index === existingSubgroupIndex) {
          return [...subgroups, action.teachers];
        }

        if (hasUpdatedTeacher) {
          return subgroups;
        }

        return [...subgroups, subgroup];
      },
      [] as SubGroup[],
    );

    if (existingSubgroupIndex === -1) {
      updatedSubgroups.push(action.teachers);
    }

    return {
      ...state,
      teachers: {
        ...state.teachers,
        subgroups: updatedSubgroups,
      },
      error: null,
    };
  }),

  on(
    courseTeachersListLoadSuccess,
    (state, action): CourseTeachersListState => ({
      ...state,
      teachers: action.teachersList,
      subId: action.subId,
      error: null,
    }),
  ),
  on(
    courseTeachersListLoadFail,
    (state, { error }): CourseTeachersListState => ({
      ...state,
      error,
    }),
  ),
);
